import React from 'react';

import { PermissionProvider } from './permission';

const AppProvider = ({ children }) => {
  return <PermissionProvider>{children}</PermissionProvider>;
};

export default AppProvider;
